// extracted by mini-css-extract-plugin
export default {"revenueContent":"Reservations_revenueContent__6n0sa","mainTable":"Reservations_mainTable__pU4oE","smallTable":"Reservations_smallTable__0ZRrd"};